import { render, staticRenderFns } from "./LearningContent.vue?vue&type=template&id=5f683dde&"
import script from "./LearningContent.vue?vue&type=script&lang=js&"
export * from "./LearningContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports